export const HTTP_STATUS_CODES = {
  OK: 200,
  ACCEPT: 202,
  CONFLICT: 409,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500
};

export const NON_NUMERIC_REGEX = /\D/g;
export const CONSECUTIVE_SPACES_REGEX = / {2,}/g;
export const NAME_VALIDATION_PATTERN = /^[\p{L}]+(?: [\p{L}]+)*$/u;
export const ROI_LABEL_APP_NAME_REGEX = /^ROI\d+-[^-]+-(.+)$/;

export const TEXT = {
  GO_TO_DASHBOARD: "Go to Dashboard",
  RELOAD_APPLICATION: "Reload Application",
  CLEAR_CACHE_AND_RETRY: "Clear cache & Re-login"
};

export const BUTTON_TEXT = {
  INVITE_USER: "Invite user"
};

export const TAB_NAMES = {
  USERS: "Users",
  USER_GROUPS: "User Groups",
  PENDING_INVITES: "Pending Invites"
};

export const USER_MANAGEMENT_ERROR_MESSAGES = {
  FETCH_USERS_FAILED: "Failed to fetch users, please reload the page.",
  FETCH_USER_GROUPS_FAILED: "Failed to fetch user groups, please reload the page.",
  FETCH_PENDING_INVITES_FAILED: "Failed to fetch pending invites, please reload the page.",
  FETCH_USERGROUPS_FAILED: "Failed to fetch users. Please try again later.",
  FETCH_USER_GROUPS_OPTIONAL_FAILED: "Failed to fetch users. Don't worry, you can still proceed to the next step since this is optional.",
  FETCHUSERS_FAILED_TITLE: "Unable to load users",
  EMPTY_USERS: "No users found. Don't worry, you can still proceed to the next step since this is optional.",
  EMPTY_USERS_TITLE: "No users available"
};

export const MODAL_TEXT = {
  ARE_YOU_SURE: "Are you sure?",
  DELETE_INVITED_USER_CONFIRM: "Are you sure you want to delete this invited user?",
  YES_DELETE_USER: "Yes, delete user",
  CANCEL: "Cancel",
  RESEND_INVITE: "Resend Invite",
  RESEND_INVITE_CONFIRM: "Are you sure you want to resend",
  RESEND_INVITE_BUTTON: "Resend Invite",
  CLOSE: "close"
};

export const TABLE_COLUMNS = {
  USER: "User",
  NAME: "Name",
  PHONE_NUMBER: "Phone Number",
  EMAIL: "Email",
  DATE_INVITED: "Date Invited",
  ADDED_BY: "Added By",
  ACTIONS: "Actions"
};

export const INVITE_USER_ERROR_MESSAGES = {
  email: "Enter a valid email",
  firstName: "Enter First Name",
  lastName: "Enter Last Name",
  firstNameInvalid: "First name must contain only letters and spaces",
  lastNameInvalid: "Last name must contain only letters and spaces",
  phoneNumber: "Must be a valid phone number",
  phoneNumberGeneric: "Enter a valid phone number.",
  emailAlreadyInvited: "User with this email ID is already invited",
  emailAlreadyExists: "User with this email ID already exists",
  emailInvalidFormat: "Invalid email format",
  userIdNotFoundForResend: "User ID not found for resend",
  failedToSendInvitation: "Failed to send invitation. The email was not sent.",
  inviteFailedGeneric: "An error occurred while inviting this user. Please try again."
};

export const INVITE_USER_SUCCESS_MESSAGES = {
  resendInvite: "Resent invite to user_name to add them to your organization.",
  inviteSent: (fullName) => `An invitation to 5G Video Insights has been sent to ${fullName}'s email.`
};

export const INVITE_USER_MODAL_CONSTANTS = {
  // Step 1 — Add user info
  STEP_ONE_TITLE: "Add user info",
  LABEL_FIRST_NAME: "First name",
  LABEL_LAST_NAME: "Last name",
  LABEL_PHONE_NUMBER: "Phone number",
  LABEL_EMAIL: "Email",
  BUTTON_CONTINUE: "Continue",

  // Step 2 — Select billing account(s)
  STEP_TWO_TITLE: "Select billing account(s)",
  NO_SITE_FOR_BAID_MESSAGE: "Not able to send Invitation. No site available for the selected Billing Account.",

  // Step 3 — Select user role
  STEP_THREE_TITLE: "Select user role",
  ROLE_ASSIGNMENT_NOTIFICATION_TITLE: "Role assignment",
  ROLE_ASSIGNMENT_NOTIFICATION_SUBTITLE: "All users must be assigned the admin role until a site has been added to this account. Once a site has been added, user roles can be changed from the User Details pages.",
  LABEL_ROLE: "Role",
  ERROR_TEXT_SELECT_ROLE: "Select a Role",
  OPTION_ADMIN: "Admin",
  BUTTON_INVITE_USER: "Invite User",

  // Step 4 — Assign user to site
  STEP_FOUR_TITLE: "Assign user to site",
  STEP_FOUR_BODY: "Select the site(s) that this user needs access to",
  SEARCH_SITES_PLACEHOLDER: "Search sites",
  LABEL_ALL_SITES: "All Sites",
  SITE_NAME_FALLBACK: "Untitled",
  BUTTON_SEND_INVITE: "Send Invite",

  // Notification metadata (NOTIFICATION_TYPE_INVITE_SENT reused from userDetailsConstants.js)
  NOTIFICATION_TYPE_INVITE_FAILED: "Invite failed",
};


export const EVENTS_INFO_CONSTANTS = {  
  // Notification messages
  EVENT_EVIDENT_REMOVAL_WARNING: "Evidence will be deleted from the 5G Video Insights cloud on",
  EVENT_VIDEO_FAILED_TO_LOAD: "Event video failed to load",
  EVENT_VIDEO_PROCESSING: "Video evidence is being processed… One moment, Please!",
  EVENT_IMAGE_AND_VIDEO_PROCESSING: "Image and Video evidence is being processed… One moment, Please!",
  EVENT_IMAGE_PROCESSING: "Image is being processed… One moment, Please!",
  EVENT_SNAPSHOT_AND_VIDEO_FAILED_TO_LOAD: "Event snapshot and video failed to load",
  EVENT_NOT_RESOLVED_SUBTITLE: "Something went wrong, Please try again later.",
  EVENT_CAPTURE_VIDEO_EVIDENCE_OFF : "Capture Video Evidence disabled for the rule.",
  EVENT_VIDEO_UPLOAD_SPEED: "Video evidence uploaded to cloud at [uploadSpeed] Mbps",
  
  REQUEST_EVENT_EVIDENTS: "An attempt to fetch evidence failed! Click on Get Evidence button to re-try.",
  EVENT_CREATED_MONTH_BACK : (availableTill) => {
  return `Evidence was deleted from the 5G Video Insights cloud on ${availableTill}.`
},
  // Event types and statuses
  EVENT_NOT_RESOLVED_TYPE: "Event not resolved",

  // Notification types (must match NotificationConfig notificationTypes)
  NOTIFICATION_TYPE_INFO: "Information",
  NOTIFICATION_TYPE_EVENTS_RESOLVED: "Events resolved",

  // Bulk resolution notifications
  RESOLUTION_IN_PROGRESS_TITLE: "Resolution in progress",
  RESOLUTION_IN_PROGRESS_SUBTITLE: "A bulk resolution operation is currently in progress. Please wait until it completes before starting another resolution.",
  RESOLUTION_IN_PROGRESS_INLINE: "A bulk resolution is currently in progress. Please wait until it completes.",

  EVENTS_RESOLVED_TITLE: "Events resolved.",
  EVENTS_RESOLVED_SUCCESS: "Selected events have been resolved.",
  EVENTS_RESOLVED_PARTIAL: "Selected events have been partially resolved.",

  EVENTS_BEING_RESOLVED_TITLE: "Events being resolved.",
  EVENTS_BEING_RESOLVED_SUBTITLE: "Due to large amount of events being resolve it may take some time to finish.",

  EVENTS_NOT_RESOLVED_TITLE: "Events not resolved.",
  EVENTS_NOT_RESOLVED_SUBTITLE: "Selected events have not been resolved.",

  // Bulk resolution UI text
  RESOLVE_SINGLE_EVENT_TITLE: "Resolve event",
  RESOLVE_BULK_EVENTS_TITLE: "Bulk resolve events",

  RESOLVE_SINGLE_EVENT_WARNING: "Resolving this event will remove it from the alerts list on the dashboard.",
  RESOLVE_BULK_EVENTS_WARNING: "Resolving all events will remove all from the alerts list on the dashboard.",

  RESOLVE_SINGLE_EVENT_CONFIRM: "I understand this event will be resolved. This action cannot be undone.",
  RESOLVE_BULK_EVENTS_CONFIRM: "I understand all events will be resolved. This action cannot be undone.",

  BULK_RESOLVE_LIMIT_ERROR_TITLE: "Cannot resolve more than",
  BULK_RESOLVE_LIMIT_ERROR_INLINE: (limit, count) =>
    `Cannot resolve more than ${limit} events at once. Current count: ${count} events. Please refine your filters to reduce the count.`,
  BULK_RESOLVE_LIMIT_ERROR_MODAL: (limit, count) =>
    `Current selection: ${count} events. Please refine your filters to reduce the count below ${limit}.`,

  // Button text
  RESOLVING_TEXT: "Resolving...",
  LOADING_TEXT: "loading...",

  EVENT_CREATED_BEFORE_MONTH: 43200,
  EVENT_CREATED_BEFORE_DAY: 60,  // DOne Intentionely to avaoid request evidence feature now will bring it next Sprint when API will be ready.,
  EVENT_CREATED_BEFORE_HOUR: 60,
  EVENT_CREATED_BEFORE_MINUTE: 1,

  DEFAULT_POLYGON_POINTS : {"polygon" : {"edges" : [
    {"pointA":{"x": 0, "y": 0}, "pointB":{"x": 0, "y": 1079}},
    {"pointA":{"x": 0, "y": 1079}, "pointB":{"x": 1919, "y": 1079}},
    {"pointA":{"x": 1919, "y": 1079}, "pointB":{"x": 1919, "y": 0}},
    {"pointA":{"x": 1919, "y": 0}, "pointB":{"x": 0, "y": 0}}
  ],
     "frame":{maxX: 1919, maxY: 1079, minX: 0, minY: 0}}}
};

export const ACTIVITY_LOG_CONSTANTS = {
  
  // Notification messages
  COLOR_SELECTION_ACCURACY_TITLE: "Color selection accuracy: ",
  COLOR_SELECTION_ACCURACY_SUBTITLE: "To improve reduce false positives, try refining the detection area or adjusting which colors to include or exclude.",
  EDIT_APPLICATION_SETTINGS_BUTTON: "Edit application settings",
  
  // Navigation and state values
  LOCATION_EVENTS_INFO: "eventsInfo",
  ACTION_UPDATE: "update",
  ORIGIN_PAGE_EVENTS_INFO: "eventsInfo",
  
  // ROI related
  ROI_EDIT_FAIL_TYPE: "ROI Edit Fail",

  // Priority levels
  PRIORITY_CRITICAL: "critical"
};



export const SELECT_APP_SITE_CONSTANTS = {
  // Header text
  HEADER_TEXT: "Start by naming the alert, then selecting the app and site that the alert will apply to.",
  
  // Form labels
  SELECT_OPTION: "Select",
  
  // Modal content
  EMPTY_SITES_MODAL_TITLE: "Empty Sites List",
  EMPTY_SITES_MODAL_BODY_LINE1: "No sites found against the selected app.",
  EMPTY_SITES_MODAL_BODY_LINE2: "Click Continue to select another app or click Cancel to return alert listing page.",
  NO_SITES: "No sites found",
};

export const SELECT_ROI_CONSTANTS = {
  // Header text
  HEADER_TEXT: "Select the regions of interest you want to include in the alert.",
  
  // Location options
  LOCATION_SITE: "Site",
  LOCATION_FLOOR: "Floor", 
  LOCATION_AREA: "Area",
  LOCATION_SUBAREA: "Sub-area",
  
  // ROI descriptions and messages
  REGIONS_OF_INTEREST: "regions of interest",
  DWELL_TIME: "dwell time",
  ENTRY_EXIT_COUNT: "entry/exit count",
  
  // Template for dynamic messages
  getApplyAlertToSiteMessage: (count, appName) => {
    const appType = appName === "Dwell Time" ? "dwell time" : "entry/exit count";
    return `Apply alert to the ${count} regions of interest contributing to the ${appType} for this site.`;
  },
  


  // No ROI messages
  NO_ROI_ENTRY_EXIT: "No regions of interest are subscribed to this app in any of the locations.",
  NO_ROI_FIXED_AREA: "No regions of interest are subscribed to this app in any of the area or sub-area under the selected site.",
  NO_ROI_FLOORS: "No regions of interest are subscribed to this app in any of the floors under the selected site.",
  NO_ROI_EVENTAPP: "No regions of interest are subscribed to this app.",
};

// Redux property names for ROI selection
export const ROI_REDUX_PROPS = {
  SELECT_AREA: "selectArea",
  SELECT_SUB_AREA: "selectSubArea",
  CHECKED_AREA_ROI: "checkedAreaRoi",
  CHECKED_SUB_AREA_ROI: "checkedSubAreaRoi",
  ROI_SELECTED: "roiSelected",
  AREA_SELECTED: "areaSelected",
  FLOOR_SELECTED: "floorSelected",
  SITE_SELECTED: "siteSelected",
  SELECTED_TAB: "selectedTab",
  SUB_AREA_SELECTED: "subAreaSelected",
  SELECTED_LOCATION: "selectedLocation",
  SITES_ROI_LIST: "sitesRoiList",
  FLOOR_DATA: "floorData",
  ROI_DATAS: "roiDatas",
  FLOOR_ROI_LIST: "floorRoiList",
  ROI_IMAGES: "roiImages",
  FLOOR_LIST: "floorList",
  RULE_NAME: "ruleName",
  APP_SELECTED: "appSelected",
  CV_APP_ROIS: "cvAppRois",
  FILTERED_SITE_LIST: "filteredSiteList",
  IS_VALID_NAME: "isValidName",
  SEL_APP_TYPE: "selAppType",
  TRIGGER_DATA: "triggerData",
  TRIGGER_ACTIONS: "triggerActions",
  COLORS_SELECTED: "colorsSelected",
  CHANGED_PARKING_OCCUPANCY: "changedParkingOccupancy",
  FLOOR_IMAGE_DATA: "floorImageData",
};

// Location type values
export const LOCATION_TYPES = {
  SITE: "site",
  FLOOR: "floor",
  AREA: "area",
  SUB_AREA: "sub-area",
};

export const FILTERS = {
  LOCATION: "Location",
  EVENTS: "Events",
  COMPANION: "Companion",
  SEVERITY: "Severity",
  STATUS: "Status"
}
export const USER_REGISTRATION_CONSTANTS = {
  INVITE_EXPIRED_TITLE: "Your Invite has expired.",
  INVITE_EXPIRED_SUBTITLE: "The link you used to accept the invite has expired.",
  INVITE_EXPIRED_SUBTITLE2: "Please, contact your admin to get a new invite.",
  PAGE_TITLE: "5G Video Insights",
  WELCOME_TITLE: "Welcome to 5G Video Insights",
  CREATE_PASSWORD_SUBTITLE: "Create a password to get started.",
  LEFT_PANEL_SUBTITLE: "Deploy, manage, and scale with AI",
  LEFT_PANEL_DESCRIPTION: "for your physical operations and transform your cameras with out-of-the-box applications.",
  WORK_EMAIL_NOTE: "Work email used for this account",
  PASSWORD_VALID_MESSAGE: "Password valid",
  PASSWORD_REQUIREMENTS_NOT_MET: "Password does not meet requirements.",
  PASSWORD_CONTAINS_EMAIL: "Password cannot contain login email.",
  PASSWORD_CONTAINS_URL: "Password cannot contain web portal URL or name.",
  PASSWORD_MIN_LENGTH_REQUIREMENT: "Password must be a minimum of 8 characters.",
  PASSWORD_COMPLEXITY_REQUIREMENT: "Must include at least one number, one uppercase, and one lowercase character.",
  VERIFY_PASSWORD_NO_MATCH: "Verify password doesn't match",
  PASSWORDS_MATCH: "Passwords match",
  CREATE_PASSWORD_BUTTON: "Create password",
  TERMS_AGREEMENT_PREFIX: "By continuing, you agree to the",
  TERMS_AND_CONDITIONS: "Terms & conditions",
  TERMS_AGREEMENT_AND: "and",
  PRIVACY_POLICY: "Privacy policy.",
};

export const SEVERITY_LEVELS = {
  MINOR: "Minor",
  CRITICAL: "Critical"
}

export const EVENT_STATUS = {
  RESOLVED: "Resolved",
  UNRESOLVED: "Unresolved"
}

export const MAX_BULK_RESOLVE_LIMIT = 1000;

export const DATE_TIME = {
  START_TIME: "startTime",
  END_TIME: "endTime"
}

export const USER_ROLE = {
  ADMIN: "admin",
  SITE_VIEWER: "site viewer",
  SITE_MANAGER: "site manager",
  USER: "USER"
}

export const NOTIFICATION_TYPES = {
    INCIDENT: "Incident",
    DEVICE: "DeviceNotification",
    DEVICE_VERSION: "ts.device.gateway.vision.companion",
    SEARCH_COMPLETED: "ts.message.forensics",
    SEARCH_RESULT_IMAGE_UPLOADED: "ts.message.forensics.search"
}

export const isUserNonAdmin = (userRole) =>
  userRole && (userRole === USER_ROLE.SITE_MANAGER ||
  userRole === USER_ROLE.SITE_VIEWER);

export const isUserAdmin = (userRole) =>
  userRole === USER_ROLE.ADMIN;

export const KEEP_ALIVE_DELAY = 15 * 1000; // 15 seconds for Ping/Pong
export const RETRY_DELAY = 3 * 1000; // 3 seconds for Watchdog reconnection
export const INITIAL_POLLING_RATE = 5 * 1000; // 5 seconds for initial polling before WS connect

export const NO_PERMISSION = "No Permission";
export const BANNER_TIMEOUT = 5 * 1000; // 5 seconds for device upgrade/downgrade notification banner display
export const IDLE_TIMEOUT_MSG = "Due to inactivity, your session will be logged out in 2 minutes. Would you like to stay logged in?";

export const DOCUMENT_EVENTS = {
  VISIBILITY_CHANGE: "visibilitychange",
  PAGE_FOCUS: "focus",
  MOUSE_MOVE: "mousemove",
  KEY_DOWN: "keydown",
  SCROLL: "scroll",
  KEY_PRESS: "keypress",
  CLICK: "click"
}

export const BANNER_TYPES = {
  INFORMATION: "Information",
  WARNING: "warning",
}

export const RESOLVE_STATUS = {
  IDLE: "idle",
  CHECKING: "checking",
  IN_PROGRESS: "in_progress",
  COMPLETE: "complete",
  ERROR: "error"
}

export const USER_GROUP_DETAILS_CONSTANTS = {
  // Button labels
  ADD_MEMBERS: "Add members",
  TOOLTIP_DELETE_USER: "Delete user",
  TOOLTIP_DELETE_GROUP: "Delete group",
  RENAME_GROUP: "Rename group",
  SAVE_NAME: "Save name",
  CREATE_GROUP: "Create group",
  BUTTON_BACK: "Back",
  BUTTON_NEXT: "Next",
  BUTTON_CANCEL: "Cancel",
  BUTTON_SUBMIT: "Submit",
  BUTTON_ADD: "Add",
  BUTTON_UPDATE: "Update",

  // Search
  SEARCH_MEMBERS_PLACEHOLDER: "Search members",
  SEARCH_USERS_PLACEHOLDER: "Search users",

  // Navigation
  SETTINGS_LINK_TEXT: "Settings",
  USER_GROUPS_LINK_TEXT: "User Groups",
  FROM_PAGE: "UserGroups",
  PAGE: "UserGroupsDetails",
  PAGE_ADD_GROUP_MODAL: "AddGroupModal",

  // Add Group modal step labels
  ADD_GROUP_TITLE: "Add Group",
  STEP_ONE_TITLE: "Assign to site",
  STEP_TWO_TITLE: "Name Group",
  STEP_TWO_BODY: "Select the site that this group will receive notifications about.",
  STEP_THREE_TITLE: "Add members",
  STEP_THREE_BODY: "The following users are available for the selected site. Please select the users you'd like to include in this group.",
  STEP_FOUR_TITLE: "Review group",

  // Add Group modal validation messages
  GROUP_NAME_DUPLICATE_ERROR: "Error—A group with this name already exists. Please try again with a different group name.",
  GROUP_NAME_EMPTY_ERROR: "Group name cannot be empty!",

  // Table column headers (NotificationGroups)
  COLUMN_GROUPS: "Groups",
  COLUMN_MEMBERS: "Members",
  COLUMN_SITE: "Site",
  COLUMN_DATE_CREATED: "Date created",

  // Form labels / table headers (Utils)
  LABEL_GROUP_NAME: "Group name",
  LABEL_SITE: "Site",
  LABEL_GROUP_MEMBERS: "Group members",
  TABLE_HEADER_USER_NAME: "User name",
  TEXT_NO_MEMBERS_SELECTED: "No members selected",
  TEXT_SELECT_A_SITE: "Select a site",
  TEXT_NO_SITES_AVAILABLE: "No Sites Available",
  TEXT_NA: "NA",

  // Legacy modal strings (UserGroupsModals)
  MODAL_USER_INFO_TITLE: "User Info",
  MODAL_GROUP_INFO_TITLE: "Group Info",
  MODAL_EDIT_GROUP_TITLE: "Edit Group",
  MODAL_CREATE_GROUP_TITLE: "Create Group",
  MODAL_EDIT_USER_TITLE: "Edit User",
  MODAL_CREATE_USER_TITLE: "Create User",
  MODAL_ADD_GROUP_TITLE: "Add Group",
  MODAL_GROUP_NAME_LABEL: "Group Name",
  MODAL_GROUP_NAME_ERROR: "Group Name can't be empty",
  MODAL_GROUP_DESCRIPTION_LABEL: "Group Description",
  MODAL_GROUP_DESCRIPTION_ERROR: "Group ID can't be empty",
  MODAL_GROUP_EMAIL_LABEL: "Group Email ID",
  MODAL_GROUP_EMAIL_ERROR: "Group Email ID can't be empty",
  MODAL_FIRST_NAME_LABEL: "First Name",
  MODAL_FIRST_NAME_ERROR: "First Name can't be empty",
  MODAL_LAST_NAME_LABEL: "Last Name",
  MODAL_LAST_NAME_ERROR: "Last Name can't be empty",
  MODAL_CONTACT_NUMBER_LABEL: "Contact Number",
  MODAL_CONTACT_NUMBER_ERROR: "Contact Number can't be empty",
  MODAL_EMAIL_ID_LABEL: "Email ID",
  MODAL_EMAIL_ID_ERROR: "Email ID can't be empty",

  // Notification types
  NOTIFICATION_TYPE_USERS_ADDED: "User(s) added to group",
  NOTIFICATION_TYPE_USER_DELETED: "User deleted from group",
  NOTIFICATION_TYPE_GROUP_RENAMED: "User group renamed",
  NOTIFICATION_TYPE_GROUP_ADDED: "User group added",
  NOTIFICATION_TYPE_GROUP_ADD_FAILED: "Failed to create User group",
  NOTIFICATION_TYPE_GROUP_DELETED: "Delete Usergroup",
  NOTIFICATION_TYPE_NO_PERMISSION: "No Permission",

  // Success / failure subtitles (dynamic — use as templates)
  USERS_ADDED_SUCCESS: (names, groupName) =>
    names.length > 1
      ? `${names} are added to the ${groupName} group`
      : `${names} has been added to the ${groupName} group`,
  USERS_ADDED_FAILURE: (names) => `${names} could not add to this group`,
  USER_DELETED_SUCCESS: (name) => `User ${name} has been removed from the group`,
  USER_DELETED_FAILURE: (name) => `Unable to delete user ${name} from the group`,
  USER_REMOVED_FAILURE: (name) => `Unable to remove user ${name} from the group`,
  GROUP_RENAMED_SUCCESS: (oldName, newName) => `Group ${oldName} is renamed to ${newName}`,
  GROUP_RENAMED_FAILURE: (oldName, newName) => `Group ${oldName} couldn't renamed to ${newName}`,
  GROUP_RENAMED_ERROR: (newName) => `Group can't be renamed to ${newName}`,
  GROUP_SYSTEM_RENAME_ERROR: "System groups cannot be renamed.",
  NO_NEW_USERS_TO_ADD: "No new users to add",
  GROUP_DELETED_SUCCESS: (name) => `Group ${name} has been deleted successfully`,
  GROUP_DELETED_FAILURE: (name) => `Group ${name} hasn't been deleted`,
  GROUP_ADDED_SUCCESS: (name) => `${name} group has been created successfully`,
  GROUP_ADDED_FAILURE: (name) => `${name} group hasn't been created`,

  // Data-testids
  TESTID_SETTINGS_LINK: "userGroupDetails_settingsLink",
  TESTID_USER_GROUPS_LINK: "userGroupDetails_userGroupsLink",
  TESTID_ADD_MEMBERS_BUTTON: "userGroupDetails_addMembersButton",
  TESTID_SAVE_RENAME_BUTTON: "userGroupDetails_saveOrRenameButton",

  // Priority
  PRIORITY_SUCCESS: "success",
  PRIORITY_CRITICAL: "critical",
}

export const DELETE_GROUP_MODAL_CONSTANTS = {
  CONFIRM_BUTTON: "Yes, delete",
  CANCEL_BUTTON: "No, cancel",
  DEFAULT_MESSAGE: "Are you sure you want to delete",
  CONFIRM_MESSAGE: "Are you sure you want to delete group",
  CONFIRM_USER_MESSAGE: "Are you sure you want to delete user",
  MODAL_TITLE: "Delete group",
  WARNING_TITLE: "Warning",
  WARNING_MESSAGE: (membersCount) =>
    `This group currently receives notifications for 25 alerts. If deleted, the ${membersCount} members of this group will no longer receive notifications for these alerts.`,
}

export const COUNTRY_SRC = "https://venkatvidyut.github.io/react-country-state-city/data";
